import { combineReducers } from 'redux';

import regions from './regions';

export default combineReducers({
    regions
});
